import React, { useEffect, useRef, useCallback, useMemo, useState } from 'react';
import Menu from 'devextreme-react/menu';
import { useNavigation } from '../../contexts/navigation';
import './top-navigation-menu.scss';
import { useLocation } from 'react-router-dom';


export default function TopNavigationMenu(props) {
    const menuItems = localStorage.getItem("menu");
    const location = useLocation();

    function normalizePath() {
      if (!menuItems) {
        // signOut();
        return [];
      }
  
      let navigation = [];
      try {
        const parsed = JSON.parse(menuItems);
        if (!Array.isArray(parsed)) {
          console.warn("Parsed menu is not an array.");
          return [];
        }
        navigation = parsed;
      } catch (err) {
        console.error("Invalid JSON in localStorage 'menu':", err);
        return [];
      }
    
      // Add "Events" after "Spaces"
      const spaceIndex = navigation.findIndex(item => item.text === "Spaces");
      if (spaceIndex !== -1) {
        navigation.splice(spaceIndex + 1, 0, {
          icon: "/icons/events.svg",
          path: "/events",
          text: "Events"
        });
      }
    
      return navigation.map(item => {
        const path = item.path && !item.path.startsWith("/") ? `/${item.path}` : item.path;
        return { ...item, path };
      });
    }


  const items = useMemo(normalizePath, []);
  const { navigationData: { currentPath } } = useNavigation();
  const normalize = (path = '') => String(path).replace(/\/+$/, '');
    const normalizedPath = useMemo(
      () => normalize(location.pathname),
      [location.pathname]
    );

    function RenderMenu(item) {
      const isSelected = normalize(item.path) === normalizedPath;
      const hasSubmenu = item.items && item.items.length > 0;
      const isSvgIcon = item.icon?.endsWith('.svg');

      return (
        <>
          {item.icon && (
            isSvgIcon ? (
              <img
                src={item.icon}
                className="dx-icon"
                alt="Menu icon"
              />
            ) : (
              <i className={`dx-icon dx-icon-${item.icon}`}></i>
            )
          )}

          <span className={`dx-menu-item-text ${isSelected ? 'active' : ''}`}>
            {item.text}
          </span>

          {hasSubmenu && (
            <span className="dx-menu-item-popout-container">
              <div className="dx-menu-item-popout"></div>
            </span>
          )}
        </>
      );
    }


    return(
      <div className="form">
        <div>
          <Menu
            dataSource={items}
            displayExpr="text"
            orientation={'horizontal'}
            hideSubmenuOnMouseLeave={true}
            onItemClick={props.selectedItemChanged}
            itemRender={(item) => RenderMenu(item)}
          />
        </div>
      </div>
    )
}